import React, { ReactNode } from 'react';
import { ThemeProvider } from 'styled-components';
import defaultTheme from '../styles/themes/default';
import GlobalStyles from '../styles/global';
import { SidebarProvider } from './SidebarContext';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { UserProvider } from './UserContext';
import { PaymentProvider } from './PaymentContext';

const queryClient = new QueryClient();
interface GlobalContextProviderProps {
  children: ReactNode;
}

const GlobalContextProvider: React.FC<GlobalContextProviderProps> = ({
  children,
}) => {
  return (
    <UserProvider>
      <QueryClientProvider client={queryClient}>
        <SidebarProvider>
          <ThemeProvider theme={defaultTheme}>
            <GlobalStyles />
            <PaymentProvider>
              {children}
            </PaymentProvider>
          </ThemeProvider>
        </SidebarProvider>
        <ReactQueryDevtools />
      </QueryClientProvider>
    </UserProvider>
  );
};

export default GlobalContextProvider;
